import { required, email ,requiredIf } from 'vuelidate/lib/validators'
import { fileSize, phone, zip } from '@/ic-common/helpers/validation'


import { isForeignBank, isBankTransfer, isEmailAgreement } from './helpers'


export default {
  form: {
    email: {
      required,
      email
    },
    message: {
      required
    },
    agreement: {
      
    },
    name: {
      firstName: { required },
      lastName: { required },
      sex: { required }
    },
    phone: { phone },
    address: {
      street: {  requiredIf: requiredIf(isEmailAgreement)  },
      streetNo: {  requiredIf: requiredIf(isEmailAgreement)  },
      zip: {  requiredIf: requiredIf(isEmailAgreement) , zip },
      city: {  requiredIf: requiredIf(isEmailAgreement)  }
    },
    files: {
      $each: {
        contact_fileSize: fileSize({ min: 0, max: 5000 })
      }
    }
  }
}
